import { render, staticRenderFns } from "./FilterAmount.vue?vue&type=template&id=71bcb381&lang=pug&"
import script from "./FilterAmount.vue?vue&type=script&lang=js&"
export * from "./FilterAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports